var _linearGradient, _linearGradient2, _linearGradient3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnsImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72.52 80.95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 41.95,
    x2: 12.57,
    y1: 2.57,
    y2: 34.42
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#a0a8d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#8791c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6470b4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 42.57,
    x2: 71.96,
    xlinkHref: "#a",
    y1: 81.66,
    y2: 49.81
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 42.26,
    x2: 42.26,
    y1: 1.24,
    y2: 82.84
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#513eff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5157ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5298ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52e5ff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -1.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.28 34.39c.8 1.71 2.78 5.09 2.78 5.09l22.89-37.84-22.34 15.6a9.75 9.75 0 0 0 -3.18 3.5 16.19 16.19 0 0 0 -.15 13.65z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.21 46.85a25.47 25.47 0 0 0 10 18.51l24.71 17.23s-15.46-22.28-28.5-44.45a22.39 22.39 0 0 1 -2.62-7.56 12.1 12.1 0 0 1 0-3.63c-.34.63-1 1.92-1 1.92a29.35 29.35 0 0 0 -2.67 8.55 52.28 52.28 0 0 0 .08 9.43z",
    fill: "#a0a8d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.25 49.84c-.8-1.71-2.78-5.09-2.78-5.09l-22.89 37.84 22.34-15.59a9.75 9.75 0 0 0 3.18-3.5 16.19 16.19 0 0 0 .15-13.66z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.32 37.38a25.47 25.47 0 0 0 -10-18.51l-24.71-17.23s15.45 22.28 28.5 44.45a22.39 22.39 0 0 1 2.61 7.56 12.1 12.1 0 0 1 0 3.63c.34-.63 1-1.92 1-1.92a29.35 29.35 0 0 0 2.67-8.55 52.28 52.28 0 0 0 -.07-9.43z",
    fill: "#a0a8d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.43 20.74a9.75 9.75 0 0 1 3.18-3.5l22.34-15.6-22.89 37.85s-2-3.38-2.78-5.09a16.19 16.19 0 0 1 .15-13.66zm-9.22 26.11a25.47 25.47 0 0 0 10 18.51l24.71 17.23s-15.46-22.28-28.5-44.45a22.39 22.39 0 0 1 -2.62-7.56 12.1 12.1 0 0 1 0-3.63c-.34.63-1 1.92-1 1.92a29.35 29.35 0 0 0 -2.67 8.55 52.28 52.28 0 0 0 .08 9.43zm63 3c-.8-1.71-2.78-5.09-2.78-5.09l-22.85 37.83 22.34-15.59a9.75 9.75 0 0 0 3.18-3.5 16.19 16.19 0 0 0 .15-13.66zm9.07-12.46a25.47 25.47 0 0 0 -10-18.51l-24.67-17.24s15.45 22.28 28.5 44.45a22.39 22.39 0 0 1 2.61 7.56 12.1 12.1 0 0 1 0 3.63c.34-.63 1-1.92 1-1.92a29.35 29.35 0 0 0 2.67-8.55 52.28 52.28 0 0 0 -.07-9.43z",
    fill: "url(#c)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnsImage);
export default __webpack_public_path__ + "static/media/ens-image.010effe074fead9f3c3fc3fdd87b2260.svg";
export { ForwardRef as ReactComponent };